import { useState } from "react";

const useValidation = (initialValue) => {
  const [state, setState] = useState(initialValue);
  const [valid, setValid] = useState({ valid: true, errorMsg: "" });

  return [state, setState, valid, setValid];
};

export default useValidation;
